export default __webpack_public_path__ + "static/media/Button-Tournaments.6a4387b3.svg";